var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5699 8.17582L16.0565 10.6248H4.90424C4.37677 10.6248 4 11.0392 4 11.529V12.4333C4 12.9608 4.37677 13.3375 4.90424 13.3375H16.0565L13.5699 15.8242C13.2308 16.1633 13.2308 16.7661 13.5699 17.1052L14.2104 17.7457C14.5495 18.0848 15.1523 18.0848 15.4914 17.7457L20.5777 12.6217C20.9545 12.2826 20.9545 11.7174 20.5777 11.3783L15.4914 6.25432C15.1523 5.91523 14.5495 5.91523 14.2104 6.25432L13.5699 6.89482C13.2308 7.23391 13.2308 7.83673 13.5699 8.17582Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.71a62aac5adf04f4f2828a2d6f9ecd66.svg";
export { ForwardRef as ReactComponent };